import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "@/hooks/useTranslation";
import { SubscriptionStatus, UserGender, UserStatus } from "@/generated-api";
import { useActiveSubscription, useGetUserProfile } from "@/tanstack-hooks";
import TextareaAutosize from "react-textarea-autosize";

export default function YourBioField({
  form,
  gender,
  optional,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
  gender: UserGender;
  optional?: boolean;
}) {
  const t = useTranslation();
  const activeSubscriptionQuery = useActiveSubscription();
  const getUserProfileQuery = useGetUserProfile();

  const hasActiveSubscription =
    activeSubscriptionQuery.data?.subscription_status ===
      SubscriptionStatus.ACTIVE ||
    activeSubscriptionQuery.data?.subscription_status ===
      SubscriptionStatus.ACTIVE_CANCELED;

  const disabledBioEdit =
    gender === UserGender.MALE &&
    (getUserProfileQuery.data?.status === UserStatus.ACTIVE ||
      getUserProfileQuery.data?.status === UserStatus.ACTIVE_HIDDEN) &&
    !hasActiveSubscription;

  return (
    <>
      <FormField
        control={form.control}
        name="bio"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr]">
            <FormLabel className={optional ? "mt-2 text-gray-400" : "mt-2"}>
              {t.USER_FORM.LABELS.YOUR_BIO}
            </FormLabel>
            <div>
              <div className="relative">
                <FormControl>
                  <TextareaAutosize
                    placeholder={t.USER_FORM.PLACEHOLDERS.BIO_INPUT}
                    className="resize-none w-full rounded-md border border-input bg-background px-3 py-2 text-base pb-6 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50"
                    {...field}
                    maxLength={250}
                    disabled={disabledBioEdit}
                    minRows={3}
                  />
                </FormControl>
                <div
                  className={`absolute bottom-2 right-2 text-xs pointer-events-none ${
                    (field.value as string)?.length >= 30
                      ? "text-green-600"
                      : "text-zinc-400"
                  }`}
                >
                  {(field.value as string)?.length ?? 0}/250
                </div>
              </div>
              {disabledBioEdit ? (
                <div className="text-xs mt-1 text-zinc-600">
                  {t.USER_FORM.LABELS.UPGRADE_TO_EDIT}
                </div>
              ) : (
                <div className="text-xs mt-1 text-zinc-600">
                  {t.USER_FORM.LABELS.CONTACT_INFO_SUSPEND}
                </div>
              )}
              <FormMessage className="mt-1" />
            </div>
          </FormItem>
        )}
      />
    </>
  );
}
